import { Controller } from 'stimulus';

// Fill view of the job Checklist tab. Every save PATCHes the item's answer
// endpoint and swaps the returned content + nav-tab tally back in. The server
// handles toggle-to-clear (re-clicking the selected option clears it).
export default class extends Controller {
  static targets = ['content'];

  answer(event) {
    const el = event.currentTarget;
    const value = el.dataset.value !== undefined ? el.dataset.value : el.value;
    this.save(el.dataset.url, { answer: value });
  }

  saveComment(event) {
    const el = event.currentTarget;
    this.save(el.dataset.url, { comment: el.value });
  }

  // Saved comments render as quiet italic text; this swaps in the editable
  // textarea on demand. Saving re-renders the content, collapsing it again.
  toggleComment(event) {
    const wrap = event.currentTarget.closest('div');
    const display = wrap.querySelector('.comment-display');
    const textarea = wrap.querySelector('textarea');
    if (display) display.classList.add('hidden');
    if (textarea) {
      textarea.classList.remove('hidden');
      textarea.focus();
      const end = textarea.value.length;
      textarea.setSelectionRange(end, end);
    }
  }

  save(url, fields) {
    const body = new FormData();
    Object.keys(fields).forEach((key) => body.append(key, fields[key]));

    fetch(url, {
      method: 'PATCH',
      credentials: 'same-origin',
      headers: {
        'X-CSRF-Token': (document.querySelector('meta[name="csrf-token"]') || {}).content,
        Accept: 'application/json',
      },
      body,
    })
      .then((response) => (response.ok ? response.json() : Promise.reject(response)))
      .then((json) => {
        this.contentTarget.innerHTML = json.content;
        const tally = document.getElementById('checklist-tab-tally');
        if (tally) tally.innerHTML = json.tally;
      })
      .catch(() => window.location.reload());
  }
}
